function LineListController($window, $filter, LineComponent, PageHeading, Toast) {
	'ngInject';

	const vm = this;

	vm.getLines = LineComponent.getLines;
	vm.deleteLine = deleteLine;
	vm.paginationInfo = LineComponent.getPaginationInfo();
	vm.loadPage = LineComponent.fetchLines;
	vm.copyLine = copyLine;

	vm.getLine = LineComponent.getLine;

	activate();

	function activate() {
		const heading = $filter('translate')('SIDEBAR.LINES');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.LINES')}`;

		PageHeading.setPageHeading(heading, title);
	}

	function deleteLine(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			LineComponent.deleteLine(id)
				.then(function(res) {
					if (res.data.errors) {
						Toast.responseError(res.data.errors);
					} else {
						Toast.success($filter('translate')('SUCCESS.DELETE_LINE'));
						if (LineComponent.getLines().length === 1 && LineComponent.getPaginationInfo().page !== 1) {
							LineComponent.fetchLines(LineComponent.getPaginationInfo().page - 1, 0, '-id', 'translation,translations,stations');
						} else {
							LineComponent.fetchLines(LineComponent.getPaginationInfo().page, 0, '-id', 'translation,translations,stations');
						}
					}
				});
		}
	}

	function copyLine(line) {
		const params = {
			'has_reverse_line': 0,
			'valid_to': line.valid_to,
			'valid_from': line.valid_from,
			'stations': [],
			'translations': line.translations
		};

		// Sort stations by position
		line.stations.sort(function (a, b) {
			return a.pivot.position - b.pivot.position;
		});

		line.stations.forEach((station) => {
			params.stations.push({
				'station_id': station.id,
				'city_id': station.city.id,
				'position': station.pivot.position
			});
		});

		LineComponent.createLine(params)
			.then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.COPY_LINE'));
					LineComponent.fetchLines(LineComponent.getPaginationInfo().page, 0, '-id', 'translation,translations,stations');
				}
			});
	}
}

export default LineListController;



/** WEBPACK FOOTER **
 ** ./client/private/lines/list/list.controller.js
 **/